// extracted by mini-css-extract-plugin
module.exports = {"accounts__container":"Screen_accounts__container__2xPGx","main":"Screen_main__3DsBd","content":"Screen_content__YUsS2"};